import { createModel } from "hox";
import { useState, useEffect } from "react";
import { IChargebackDetail, IChargebackSearch } from "./chargebackType";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import { transPgToPagination, repairFormatNum } from "@/utils/utils";
import { ISearchPage } from "@/types/ScmTypes";
import { chargebackService } from "./chargebackService";
import { message } from "antd";
import useGlobalModel from "@/model/globalModel";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { convertRes2Blob } from "@/utils/exportFile";
import { useLockFn } from "ahooks";
export interface IDescTotal {
    discountTotalAmount: number, // 321.94
    receivableAmount: number, // 2390.3
    receivableTotalAmount: number, // 7970.01
    totalAmount: number, // 8291.94
    workHour: number,
    materialNum: number
}
export interface IPrint {
    visible: boolean,
    type: number,
}
export const useChargebackModel = createModel(function () {
    const { shopAndOrg, setLoadingInfo } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);
    const [print, setPrint] = useState<boolean>(false);
    const initDesc = {
        discountTotalAmount: 0, // 321.94
        receivableAmount: 0, // 2390.3
        receivableTotalAmount: 0, // 7970.01
        totalAmount: 0, // 8291.94
        workHour: 0,
        materialNum: 0
    }
    useEffect(() => {
        // setSelectedRowKeys([]);
        reset();
    }, [shopAndOrg.shopCode])
    const initSearchParam: IChargebackSearch = {};
    const initDataSource: IChargebackDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IChargebackSearch>(initSearchParam);
    const [printParam, setPrintParam] = useState<IChargebackSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IChargebackDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IChargebackDetail>({});
    const [descTotal, setDescTotal] = useState<IDescTotal>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<IDescTotal>(initDesc);
    const [descRows, setDescRows] = useState<IChargebackDetail[]>([]);

    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [loading, setLoading] = useState<boolean>(false)
    //结算单打印
    const [printSettleVisible, setPrintSettleVisible] = useState<boolean>(false);

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IChargebackDetail)
    }, [selectedRowKeys, dataSource])
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { discountTotalAmount, receivableTotalAmount, receivableAmount, totalAmount, materialNum, workHour } = item
            newRowsDescTotal.discountTotalAmount += +repairFormatNum(discountTotalAmount)
            newRowsDescTotal.receivableAmount += +repairFormatNum(receivableAmount)
            newRowsDescTotal.receivableTotalAmount += +repairFormatNum(receivableTotalAmount)
            newRowsDescTotal.totalAmount += +repairFormatNum(totalAmount)
            newRowsDescTotal.workHour += +repairFormatNum(workHour)
            newRowsDescTotal.materialNum += +repairFormatNum(materialNum)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])

    const updateSearchParam = (updateParam: IChargebackSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IChargebackSearch = searchParam) => {
        setLoading(true)
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        setPrintParam(searchParams);
        let { retData } = await chargebackService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setLoading(false)
    }
    const loadTotal = async (searchParams: any) => {
        let { retData: statistics } = await chargebackService.total(searchParams);
        setDescTotal(statistics)
    }
    const invalidateData = async (obj: object) => {
        let { retData } = await chargebackService.invalidate(obj)
        if (retData) {
            message.success("作废成功");
            loadData();
        }
    }
    const tran = useLockFn(async (obj: object) => {
        let { retData } = await chargebackService.tran(obj)
        loadData();
        return retData
    })

    const exportMaintenance = async (searchValue: IChargebackSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            id: selectedRowKeys.join(),
        }
        try {
            let result = await chargebackService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }
    }
    const [scaniaPrint, setScaniaPrint] = useState<IPrint>({ visible: false, type: 1 });
    const [settleScaniaPrint, setSettleScaniaPrint] = useState<boolean>(false);
    const detailsExport = async (searchValue: IChargebackSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            id: selectedRowKeys.join(),
        }
        try {
            let result = await chargebackService.detailsExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }

    return {
        searchParam, loading,
        dataSource,
        selectedRowKeys,
        selectedRow,
        pgCfg,
        initPgCfg,
        setSearchParam,
        setDataSource,
        setSelectedRowKeys,
        setSelectedRow,
        setPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        invalidateData,
        tran,
        print, setPrint,
        exportMaintenance,
        descTotal, setDescTotal,
        scaniaPrint, setScaniaPrint,
        settleScaniaPrint, setSettleScaniaPrint,
        detailsExport,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        reset,
        printSettleVisible, setPrintSettleVisible,
        printParam, setPrintParam
    }
})